export const enum CONTENT_TARGET_ENUM {
  NONE = 'none',
  PORTAL = 'portal',
}

export const enum USER_CONTENT_ENUM {
  MEDIA = 'media',
  IMAGE = 'image',
  CAMERA_IMAGE = 'cameraImage',
  VIDEO = 'video',
  AUDIO = 'audio',
  TEXT = 'text',
  FILE = 'file',
  PDF = 'pdf',
  LINK = 'link',
  ASSET = 'asset',
  PORTAL = 'portal',
}
